import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import Layout from '../../components/Layout/AdminLayout/AdminLayout';

import news1 from '../../assets/news-1.png';
import news2 from '../../assets/news-2.png';
import news1Mobile from '../../assets/news-1-mobile.png';
import news2Mobile from '../../assets/news-2-mobile.png';
import dashIcon1 from '../../assets/members-dash.png';
import dashIcon2 from '../../assets/loan-dash.png';
import dashIcon3 from '../../assets/due-dash.png';

import SliderWithThumbs from '../../components/Slider/SliderWithThumbs';

import dashboardService from './dashboardService';
import { AxiosResponse } from 'axios';
import { ApiResponse } from "../../interface/IResponse";
import { IDashboardLoanStatusTotals } from '../../interface/IDashboard';

const slide = [
    {
        content: (
            <div className="news-item">
                <img src={news1} className="news-web" alt="News 1" />
                <img src={news1Mobile} className="news-mobile" alt="News 1 Mobile" />
            </div>
        ),
        thumb: <div className="thumb-box"></div>,
    },
    {
        content: (
            <div className="news-item">
                <img src={news2} className="news-web" alt="News 2" />
                <img src={news2Mobile} className="news-mobile" alt="News 2 Mobile" />
            </div>
        ),
        thumb: <div className="thumb-box"></div>,
    },
];
function Dashboard() {


    const [totalMembers, setTotalMembers] = useState<number>(0);
    const [totalLoans, setTotalLoans] = useState<number>(0);
    const [incomingDues, setIncomingDues] = useState<number>(0);
    const [loanStatusTotals, setLoanStatusTotals] = useState<IDashboardLoanStatusTotals>({ totalPending: 0, totalOngoing: 0 });


    async function loadTotalNumberMembers() {

        try {
            var response: AxiosResponse<ApiResponse<number>> = await dashboardService.getTotalNumberOfMembers();

            setTotalMembers(response.data.result);
        }
        catch (err) {
            throw err;
        }
    }

    async function loadTotalNumberLoans() {

        try {
            var response: AxiosResponse<ApiResponse<number>> = await dashboardService.getTotalNumberOfLoans();

            setTotalLoans(response.data.result);
        }
        catch (err) {
            throw err;
        }
    }

    async function loadTotalNumberIncomingDueDates() {

        try {
            var response: AxiosResponse<ApiResponse<number>> = await dashboardService.getTotalNumberOfIncomingDueDates();

            setIncomingDues(response.data.result);
        }
        catch (err) {
            throw err;
        }
    }

    async function loadLoanStatusTotals() {

        try {
            var response: AxiosResponse<ApiResponse<IDashboardLoanStatusTotals>> = await dashboardService.getLoanStatusTotals();

            setLoanStatusTotals(response.data.result);
        }
        catch (err) {
            throw err;
        }
    }

    useEffect(function () {
        (async () => {

            document.querySelector('.loader-container')?.classList.add('loader');

            await loadTotalNumberMembers();
            await loadTotalNumberLoans();
            await loadTotalNumberIncomingDueDates();
            await loadLoanStatusTotals();

            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    return (
        <Layout>
            <div className="title-container">
                <div className="dv-title">
                    <div className='title-content'>
                        <h1>Dashboard</h1>
                    </div>


                </div>
            </div>
            <br />
            <div className='dash-cards'>
                <a className='card-items' href='/Admin/MembersRegistry'><div><span>Total members</span>{totalMembers.toLocaleString()}</div><img src={dashIcon1} /></a>
                <a className='card-items' href='/Admin/LoanManagement?filter=ongoing'><div><span>Total Active Loans</span>{loanStatusTotals.totalOngoing.toLocaleString()}</div><img src={dashIcon2} /></a>
                <a className='card-items' href='/Admin/LoanManagement?filter=pending'><div><span>Pending Loans</span>{loanStatusTotals.totalPending.toLocaleString()}</div><img src={dashIcon2} /></a>
                <a className='card-items'><div><span>Incoming dues</span>{incomingDues.toLocaleString()}</div><img src={dashIcon3} /></a>
             </div>

            <div className="title-container">
                <div className="dv-title">
                    <div className='title-content'>
                        <h1>Announcements</h1>
                    </div>


                </div>
            </div>
            <br />
            <div className='adminContainer'>
                <div className='section1'>
                    <SliderWithThumbs slides={slide} />
                </div>
            </div>
            {/* <div className='content-container'>
                <div className='padding-container'>

                    <div className='container-header'>
                        <h1>Full Member Info</h1>
                    </div>

                </div>
            </div> */}
        </Layout>
    );
}

export default Dashboard;